import React from "react";
import { Link } from "react-router-dom";
import { MdExpandMore, MdOutlineChevronRight } from "react-icons/md";
import styles from "./Navigation.module.scss";

function renderIcon(IconComponent) {
  if (!IconComponent) return null;
  if (typeof IconComponent === "function") return <IconComponent />;
  if (React.isValidElement(IconComponent)) return IconComponent;
  return null;
}

function NavSubItems({
  items,
  expandedSubMenus,
  onToggleGroup,
  onClose,
  showLabels,
  depth = 0,
}) {
  if (!items?.length) return null;

  return (
    <ul
      className={`${styles["navigation-container__content__ul"]} ${
        depth > 0 ? styles["navigation-container__content__ul--nested"] : ""
      }`}
    >
      {items.map((item) => {
        const hasChildren = item.items?.length > 0;
        const isExpanded = expandedSubMenus.has(item.id);
        const siblingGroups = items.filter((i) => i.items?.length > 0);

        if (hasChildren) {
          return (
            <li
              key={item.id}
              className={`${styles["navigation-container__content__ul--li"]} ${
                styles["navigation-container__content__ul--li--group"]
              } ${
                item.active
                  ? styles["navigation-container__content__ul--li--active-group"]
                  : ""
              }`}
            >
              <button
                type="button"
                className={`${styles["navigation-container__content__ul--li--link"]} ${styles["navigation-container__content__ul--li--group-btn"]}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleGroup(item, siblingGroups);
                }}
              >
                <span
                  className={
                    styles["navigation-container__content__ul--li--sub-icon"]
                  }
                >
                  {renderIcon(item.icon)}
                </span>
                {showLabels && (
                  <span
                    className={
                      styles["navigation-container__content__ul--li--item-text"]
                    }
                  >
                    {item.name}
                  </span>
                )}
                {showLabels && (
                  <span className={styles["navigation-container__group-chevron"]}>
                    {isExpanded ? <MdExpandMore /> : <MdOutlineChevronRight />}
                  </span>
                )}
              </button>
              {isExpanded && (
                <NavSubItems
                  items={item.items}
                  expandedSubMenus={expandedSubMenus}
                  onToggleGroup={onToggleGroup}
                  onClose={onClose}
                  showLabels={showLabels}
                  depth={depth + 1}
                />
              )}
            </li>
          );
        }

        return (
          <li
            key={item.id}
            className={`${styles["navigation-container__content__ul--li"]} ${
              item.active
                ? styles["navigation-container__content__ul--li--active"]
                : ""
            }`}
          >
            <Link
              to={item.url || "#"}
              target={item?.target || "_self"}
              onClick={onClose}
              className={styles["navigation-container__content__ul--li--link"]}
            >
              <span
                className={
                  styles["navigation-container__content__ul--li--sub-icon"]
                }
              >
                {renderIcon(item.icon)}
              </span>
              {showLabels && (
                <span
                  className={
                    styles["navigation-container__content__ul--li--item-text"]
                  }
                >
                  {item.name}
                </span>
              )}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

export default NavSubItems;
